// extracted by mini-css-extract-plugin
export default {"gravatar":"iwHwV","gravatarFallback":"IHBsq","login":"ELWSW","loginText":"a3Gl4","logoutButton":"HLmSD","dropdown":"TF2Ho"};